const Link = {
  baseStyle: {
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '20px',
    fontStyle: 'normal',
    color: '#F7F7F7',
  },
}

export const LinkComponent = {
  ...Link,
}
